import React, { useState } from 'react'
import { Controller } from 'react-hook-form'

import Checkbox from '@mui/material/Checkbox'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormGroup from '@mui/material/FormGroup'
import FormHelperText from '@mui/material/FormHelperText'
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

export default function CustomCheckbox({
  id,
  control,
  required,
  label,
  options,
  error,
  helperText,
}) {
  const { spacing } = useTheme()
  const [selected, setSelected] = useState(() => {
    let _selected = {}
    options.forEach(({ value }) => (_selected[value] = false))
    return _selected
  })

  return (
    <div style={{ padding: spacing(2, 0) }}>
      <FormControl>
        <Typography variant="caption" color={error === undefined ? 'textSecondary' : 'error'}>
          {label}
        </Typography>
        <Controller
          render={({ field }) => (
            <FormGroup>
              {options.map(({ label, value }) => (
                <FormControlLabel
                  key={value}
                  control={
                    <Checkbox
                      name={value}
                      checked={selected[value]}
                      onChange={(e) => {
                        const _selected = { ...selected, [e.target.name]: e.target.checked }
                        setSelected(_selected)
                        const newValue = Object.entries(_selected)
                          .filter(([value, bool]) => bool)
                          .map(([value]) => value)
                          .join(',')
                        field.onChange(newValue)
                      }}
                    />
                  }
                  label={label}
                />
              ))}
            </FormGroup>
          )}
          defaultValue=""
          control={control}
          name={id}
          rules={{ required }}
        />
        {Boolean(helperText) && <FormHelperText>{helperText}</FormHelperText>}
        {error && <FormHelperText error>必須項目です</FormHelperText>}
      </FormControl>
    </div>
  )
}
